import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Community from './community/community'
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import TechNews from './technews-page/technews-page'
import Freelance from './freelance/index'
import Page404 from './assets/pagenotfound.svg'
import './custom.scss'
import Categories from './freelance/categories'
import Ourwork from './freelance/ourwork'
import MyOrders from './freelance/myOrders'
import {auth} from './firebase/firebase-utils'

export function PageNotFound(){
    return(
        <div style={{display:'flex', justifyContent:'center',flexDirection:'column',alignItems:'center', marginTop:'250px'}}>
            <img src={Page404} alt="" style={{height:'300px'}}/>
            <h4 style={{fontFamily:'Viga'}}><span style={{color:'tomato'}}>Error 404! </span> Page Not Found</h4>
        </div>
    )
}

function Default() {
    const [User,setuser] = React.useState(null)
    React.useEffect(()=>{
        auth.onAuthStateChanged(user=>{
            if(user){
                setuser(user)
            }
        })
    })
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={App} />
                <Route path="/community" component={Community} /> 
                <Route path="/technews" component={TechNews} />
                <Route path="/freelance" exact render={()=> {return(<Freelance user={User}/>)}} />
                <Route path="/freelance/ourwork" exact render={()=> {return(<Ourwork user={User}/>)}} />
                <Route path='/freelance/myOrders' render={() => <MyOrders user={User}/>} />
                <Route path='/freelance/:category' render={() => <Categories user={User} />} />
                <Route component={PageNotFound} />
            </Switch>
        </Router>
    )
}

ReactDOM.render(<Default />, document.getElementById('root'));
